// extracted by mini-css-extract-plugin
export default {"container":"CustomerLogoUpload_container__QXLO9","delete":"CustomerLogoUpload_delete__IaGQc","alert":"CustomerLogoUpload_alert__BjohF","logo":"CustomerLogoUpload_logo__hQeyP"};